
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { ChatInterface, FilterRequestData, ProfileMapInterface } from '@/services/QC-V2/chat/interfaces';
import { UserRepoInterface } from '@/services/Users/Interfaces';

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
    'userRepository',
  ],
})
export default class ChatsRows extends Vue {
  private filteredChats: ChatInterface[] = [];
  @Prop() private chats!: ChatInterface[];
  @Prop({ default: () => [] }) private disabledChatIds!: string[];
  @Prop({ default: '' }) private chatId!: string;
  @Prop({
    default: () => {
    },
  }) private filter!: FilterRequestData;

  private readonly userRepository!: UserRepoInterface;

  private selectedChatId: string = '';

  @Watch('chatId')
  private setChatId(): void {
    if (this.chatId === '') {
      return;
    }

    this.selectedChatId = this.chatId;
  }

  @Watch('chats')
  private async updateChats(): Promise<void> {
    this.filteredChats = this.chats;
    await this.filterRows();
  }

  private async filterRows(): Promise<void> {
    if (!this.filter || !this.filter['agent.email']) {
      return;
    }

    const [user] = await this.userRepository.getUsersByEmails([String(this.filter['agent.email'])]);
    if (!user) {
      return;
    }

    this.filteredChats = this.chats
      .filter((chat) => !chat.reviews.find((review) => !review.isDraft && review.reviewedId === user.id));

    this.$emit('filtered');
  }

  private getChat(id: string): void {
    this.selectedChatId = id;
    this.$emit('get-chat', id);
  }

  private alertIconVisible(chat: ChatInterface): boolean {
    const reviewsCount = chat.reviews.filter((review) => !review.isDraft).length;
    return reviewsCount > 0 && reviewsCount !== chat.agents.length;
  }
}
